// RB-MY01-PalmGarden.web/src/components/PlantForm/components/FormSections/Landscaping.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from '../SectionCard';
import { FormSectionProps } from '../../types';
import { sectionThemes } from '../../styles';

const Landscaping: React.FC<FormSectionProps> = ({ 
  plant
}) => {
  return (
    <SectionCard 
      title="Landscaping Features" 
      icon={<i className={sectionThemes.landscaping.iconName} style={{ marginRight: '8px' }} />}
      theme={{ color: sectionThemes.landscaping.color }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>
          Landscaping section is under construction.
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default React.memo(Landscaping);
